import React from "react";

function Teaching0202() {
	return (
	<div className="content_inpage">
		<div className="pagesize">
			<ul className="bread">
				<li><a href="/">首頁</a></li>						
				<li><a href="/container/teaching">教學&QA</a></li>
				<li><a href="/container/teaching/Teaching0202">智慧家電教學</a></li>
			</ul>		
					
			<h2 className="tit_main">智慧家電教學</h2>
			<div className="content_box">
				<div className="steps steps_x3 flex_set">
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step1</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_appliance01.jpg").default} alt="img_step_appliance01"/></div>
						<div className="sb_txt">
							<p>從首頁點擊「新增設備」鈕。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step2</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_appliance02.jpg").default} alt="img_step_appliance02"/></div>
						<div className="sb_txt">
							<p>選擇匯入家電設備的種類，此處選擇「Panasonic」。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step3</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_appliance03.jpg").default} alt="img_step_appliance03"/></div>
						<div className="sb_txt">
							<p>step1：依說明下載及安裝Panasonic智慧家電APP。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step4</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_appliance04.jpg").default} alt="img_step_appliance04"/></div>
						<div className="sb_txt">
							<p>step2：依說明註冊及登入Panasonic智慧家電APP。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step5</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_appliance05.jpg").default} alt="img_step_appliance05"/></div>
						<div className="sb_txt">
							<p>step3：依說明完成Panasonic智慧家電設定。完成後點擊「匯入設備」。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step6</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_appliance06.jpg").default} alt="img_step_appliance06"/></div>
						<div className="sb_txt">
							<p>輸入已註冊並完成綁定Panasonic智慧家電APP的帳號與密碼，輸入完畢後，點擊「登入」鈕。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step7</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_appliance07.jpg").default} alt="img_step_appliance07"/></div>
						<div className="sb_txt">
							<p>點擊「同意」鈕。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step8</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_appliance08.jpg").default} alt="img_step_appliance08"/></div>
						<div className="sb_txt">
							<p>匯入Panasonic帳號下的所有家電設備，此處能修改家電的「名稱」與所在「空間」。完成後，點擊「完成」鈕。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step9</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_appliance09.jpg").default} alt="img_step_appliance09"/></div>
						<div className="sb_txt">
							<p>此次匯入的家電。若家電是開啟狀態，會有「開啟」圖示，並顯示設定的數值。確認後，點擊左上角「 &lt; 」圖示，回到首頁</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step10</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_appliance10.jpg").default} alt="img_step_appliance10"/></div>
						<div className="sb_txt">
							<p>首頁顯示匯入的家電設備與所在的空間。若要查看設備狀態，可選擇右上角的「設備列表」圖示。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step11</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_appliance11.jpg").default} alt="img_step_appliance11"/></div>
						<div className="sb_txt">
							<p>開啟功能選單頁，選擇「設備管理」。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step12</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_appliance12.jpg").default} alt="img_step_appliance12"/></div>
						<div className="sb_txt">
							<p>在設備列表頁的下拉選單，切換「Panasonic」。即可到畫面9，查看家電狀態</p>
						</div>
					</div>
				</div>
			</div>
		</div>						
	</div>

	)
}

export default Teaching0202;